import { render, staticRenderFns } from "./CrearSolicitud.vue?vue&type=template&id=604610f2&scoped=true&"
import script from "./CrearSolicitud.vue?vue&type=script&lang=ts&"
export * from "./CrearSolicitud.vue?vue&type=script&lang=ts&"
import style0 from "./CrearSolicitud.vue?vue&type=style&index=0&id=604610f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604610f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('604610f2', component.options)
    } else {
      api.reload('604610f2', component.options)
    }
    module.hot.accept("./CrearSolicitud.vue?vue&type=template&id=604610f2&scoped=true&", function () {
      api.rerender('604610f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SimBajaIndividual/CrearSolicitud.vue"
export default component.exports